/*
 * @Author: yeyimei
 * @Date: 2023-03-24 17:42:34
 * @LastEditTime: 2023-04-18 09:25:49
 * @LastEditors: yeyimei
 * @Description:
 * @FilePath: \cardlan-h5-qrcode\src\router\coupon.routes.js
 */
export default [
  {
    path: '/coupon',
    name: 'couponCenter',
    component: () => import('@/views/couponCenter/couponSort.vue'),
    meta: {
      title: '天天神券',
      showName: true,
    },
  },
  {
    path: '/couponDetail',
    name: 'couponDetail',
    component: () => import('@/views/couponCenter/couponDetail.vue'),
    meta: {
      title: '天天神券',
      showName: true,
    },
  },
  {
    path: '/couponReceive',
    name: 'couponReceive',
    component: () => import('@/views/couponCenter/couponReceive.vue'),
    meta: {
      title: '天天神券',
      showName: true,
    },
  },
]
